import { SharedStoreState } from '../types/store';

export const selectWorkspaces = (state: SharedStoreState) => {
	return state.stylovyzeWorkspaces.workspaces;
};
